export default __webpack_public_path__ + "static/media/020-farmer.1b75768b.svg";